import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

import jobs from '../jobs';

export default function ApplyInfoPage() {
    const { id } = useParams();
    const [info, setInfo] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        axios.get('/api/manage/apply/'+id)
            .then((res) => {
                setInfo(res.data);
            })
            .catch((err) => console.error("상세 정보를 불러오지 못했습니다.", err))
            .finally(() => setLoading(false));
    }, [id]);

    if (loading) {
        return <div style={{ textAlign: "center", marginTop: 60 }}>로딩 중...</div>;
    }
    if (!info) {
        return <div style={{ textAlign: "center", marginTop: 60, color: "#ff4d4f" }}>상세 정보를 불러올 수 없습니다.</div>;
    }

    function accept() {
        axios.post('/api/manage/apply/'+id+'/accept')
            .then((res) => console.log('수락 성공'))
            .catch((err) => console.log('수락 실패'))
            .finally(() => { alert("수락 성공"); window.location.href = '/apply' });
    }

    function deny() {
        axios.post('/api/manage/apply/'+id+'/deny')
            .then((res) => console.log('거절 성공'))
            .catch((err) => console.log('거절 실패'))
            .finally(() => window.location.href = '/apply');
    }

    return (
        <div style={{ maxWidth: 600, margin: "40px auto", fontFamily: "sans-serif" }}>
            <h2 style={{ textAlign: "center", marginBottom: 24 }}>제휴 신청 상세정보</h2>
            <table style={{ width: "100%", borderCollapse: "collapse", background: "#fafbfc", borderRadius: 8, overflow: "hidden" }}>
                <tbody>
                    <tr>
                        <th style={thStyle}>User ID</th>
                        <td style={tdStyle}>{info.userId}</td>
                    </tr>
                    <tr>
                        <th style={thStyle}>회사명</th>
                        <td style={tdStyle}>{info.companyName}</td>
                    </tr>
                    <tr>
                        <th style={thStyle}>대표전화</th>
                        <td style={tdStyle}>{info.mainPhone}</td>
                    </tr>
                    <tr>
                        <th style={thStyle}>휴대전화</th>
                        <td style={tdStyle}>{info.mobilePhone}</td>
                    </tr>
                    <tr>
                        <th style={thStyle}>팩스번호</th>
                        <td style={tdStyle}>{info.faxNum}</td>
                    </tr>
                    <tr>
                        <th style={thStyle}>주소</th>
                        <td style={tdStyle}>{info.address}</td>
                    </tr>
                    <tr>
                        <th style={thStyle}>지역</th>
                        <td style={tdStyle}>{(info.locales || []).join(", ")}</td>
                    </tr>
                    <tr>
                        <th style={thStyle}>업종</th>
                        <td style={tdStyle}>
                            {(info.jobs || [])
                                .map(code => {
                                    const job = jobs.find(j => j.key === code);
                                    return job ? job.label : code;
                                })
                                .join(", ")
                            }
                        </td>
                    </tr>
                    <tr>
                        <th style={thStyle}>이메일</th>
                        <td style={tdStyle}>{info.email}</td>
                    </tr>
                    <tr>
                        <th style={thStyle}>사업자번호</th>
                        <td style={tdStyle}>{info.registrationNum}</td>
                    </tr>
                    <tr>
                        <th style={thStyle}>사업자등록증</th>
                        <td style={tdStyle}>
                            {info.registrationFile ? (
                                <div>
                                    <div style={{ marginTop: 8 }}>
                                        <img
                                            src={`/api/manage/apply/${id}/file`}
                                            alt="사업자등록증 미리보기"
                                            style={{ maxWidth: 200, maxHeight: 200, border: "1px solid #eee", borderRadius: 4 }}
                                        />
                                    </div>
                                    <a href={`/api/manage/apply/${id}/file`} target="_blank" rel="noopener noreferrer">
                                        {info.registrationFile}
                                    </a>
                                </div>
                            ) : "없음"}
                        </td>
                    </tr>
                    <tr>
                        <th style={thStyle}>신청일</th>
                        <td style={tdStyle}>{new Date(info.createdAt).toLocaleDateString()}</td>
                    </tr>
                </tbody>
            </table>
            <div style={{ display: "flex", justifyContent: "center", gap: 16, marginTop: 32 }}>
                <button
                    style={{
                        background: "#1677ff",
                        color: "#fff",
                        border: "none",
                        borderRadius: 4,
                        padding: "10px 32px",
                        fontWeight: 600,
                        cursor: "pointer"
                    }}
                    onClick={() => accept()}
                >
                    수락
                </button>
                <button
                    style={{
                        background: "#ff4d4f",
                        color: "#fff",
                        border: "none",
                        borderRadius: 4,
                        padding: "10px 32px",
                        fontWeight: 600,
                        cursor: "pointer"
                    }}
                    onClick={() => deny()}
                >
                    거절
                </button>
            </div>
        </div>
    );
}

const thStyle = {
    background: "#f5f6fa",
    textAlign: "left",
    padding: "10px 8px",
    fontWeight: 600,
    width: 120,
    borderBottom: "1px solid #e1e1e1"
};

const tdStyle = {
    padding: "10px 8px",
    borderBottom: "1px solid #f0f0f0"
};